import React from 'react';
import { Link } from 'react-router-dom';
import { Target, Users } from 'lucide-react';
import OptimizedImage from './OptimizedImage';

const Hero = () => {
  return (
    <section className="hero-gradient py-2 py-md-5" style={{ paddingTop: '100px' }}>
      <div className="container">
        <div className="row align-items-center justify-content-center" style={{ minHeight: 'calc(100vh - 120px)' }}>
          <div className="col-12 col-md-10 text-center" style={{ paddingTop: '1rem' }}>
            <h1 className="display-4 fw-bold text-dark mb-3 mb-md-4" style={{ 
              wordBreak: 'break-word', 
              fontSize: 'clamp(1.5rem, 6vw, 3.5rem)',
              lineHeight: '1.2',
              marginTop: '0.5rem',
            }}>
              Find Your Dream College with{' '}
              <span className="text-primary">Grad Vikalp!</span>
            </h1>
            
            <p className="lead mb-3 mb-md-5 mx-auto px-2" style={{ 
              maxWidth: '600px', 
              fontSize: 'clamp(1rem, 4vw, 1.25rem)',
              lineHeight: '1.4',
            }}>
              Verified reviews, Personalized college lists & real student connects – All in one place!
            </p>

            <div className="d-flex flex-column gap-2 gap-md-3 justify-content-center mb-3 mb-md-5 px-2">
              <Link 
                to="/Student-Connect"
                className="btn btn-gradient btn-lg d-flex align-items-center justify-content-center gap-2"
                style={{ minHeight: '56px', fontSize: '1.1rem', fontWeight: '600' }}
                aria-label="Get connect to students from your targeted college"
              >
                <Target size={20} />
                <span>Student Connect</span>
              </Link>
              
              <Link 
                to="/neet-college-predictor"
                className="btn btn-success btn-lg d-flex align-items-center justify-content-center gap-2"
                style={{ minHeight: '56px', fontSize: '1.1rem', fontWeight: '600' }}
                aria-label="Get NEET college predictions for medical colleges"
              >
                <Target size={20} />
                <span>NEET Predictor</span>
              </Link>
              
              <Link 
                to="/college-reviews"
                className="btn btn-outline-primary btn-lg d-flex align-items-center justify-content-center gap-2"
                style={{ minHeight: '56px', fontSize: '1.1rem', fontWeight: '600' }}
                aria-label="Explore college reviews and ratings"
              >
                <Users size={20} /> 
                <span>Explore Colleges</span>
              </Link>
            </div>

            {/* Hero Image */}
            <div className="row justify-content-center">
              <div className="col-12 col-lg-10 px-2 px-md-4">
                <div className="p-1 p-md-4 bg-gradient-to-r from-blue-100 to-purple-100 rounded-4 shadow-lg" style={{ marginBottom: '0.5rem' }}>
                  <OptimizedImage
                    src="/hero.webp"
                    alt="Happy students celebrating on college campus - Find your dream college with Grad Vikalp"
                    title="Students celebrating college success - Your journey starts with Grad Vikalp"
                    className="img-fluid hero-image"
                    style={{ height: 'clamp(140px, 25vw, 400px)', width: '100%', objectFit: 'cover' }}
                    priority={true}
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 80vw, 800px"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;